import {
  NumberFormatterProps as MantineNumberFormatterProps,
  NumberFormatter as MantineNumberFormatter,
} from '@mantine/core';

export type NumberFormatterProps = MantineNumberFormatterProps;

export const NumberFormatter = (props: NumberFormatterProps) => {
  return <MantineNumberFormatter {...props} />;
};

NumberFormatter.displayName = 'NumberFormatter';
